import { render, staticRenderFns } from "./CatalogoFactores.vue?vue&type=template&id=777f1b62&"
import script from "./CatalogoFactores.vue?vue&type=script&lang=js&"
export * from "./CatalogoFactores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports